import React, { FC, useMemo } from 'react'
import { useLocation, useHistory } from 'react-router'
import { PlayerProfileResponse } from 'protos'

import { decodePlayerLayerParams } from './lib'
import PlayerLayer from './PlayerLayer'

type Props = {
  getGamePlayerProfile: (gameId: string, userId: string) => Promise<PlayerProfileResponse>
  getMatchPlayerProfile: (matchId: string, userId: string) => Promise<PlayerProfileResponse>
}

const PlayerLayerProvider: FC<Props> = ({
  getGamePlayerProfile,
  getMatchPlayerProfile,
  children,
}) => {
  const location = useLocation()
  const { goBack } = useHistory()

  const search = new URLSearchParams(location.search)
  const { playerId, gameId, matchId } = decodePlayerLayerParams(search.get('playerLayer'))

  const { getProfileForGame, getProfileForMatch } = useMemo(() => ({
    getProfileForGame: gameId
      ? () => getGamePlayerProfile(gameId, playerId)
      : undefined,
    getProfileForMatch: matchId
      ? () => getMatchPlayerProfile(matchId, playerId)
      : undefined,
  }), [getGamePlayerProfile, getMatchPlayerProfile, playerId, gameId, matchId])

  return (
    <>
      {children}

      {getProfileForGame && (
        <PlayerLayer
          onClose={goBack}
          getPlayerProfile={getProfileForGame}
        />
      )}

      {getProfileForMatch && (
        <PlayerLayer
          onClose={goBack}
          getPlayerProfile={getProfileForMatch}
        />
      )}
    </>
  )
}

export default PlayerLayerProvider
try {
    // @ts-ignore
    PlayerLayerProvider.displayName = "PlayerLayerProvider";
    // @ts-ignore
    PlayerLayerProvider.__docgenInfo = { "description": "", "displayName": "PlayerLayerProvider", "props": { "getGamePlayerProfile": { "defaultValue": null, "description": "", "name": "getGamePlayerProfile", "required": true, "type": { "name": "(gameId: string, userId: string) => Promise<any>" } }, "getMatchPlayerProfile": { "defaultValue": null, "description": "", "name": "getMatchPlayerProfile", "required": true, "type": { "name": "(matchId: string, userId: string) => Promise<any>" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/PlayerLayer/PlayerLayerProvider.tsx#PlayerLayerProvider"] = { docgenInfo: PlayerLayerProvider.__docgenInfo, name: "PlayerLayerProvider", path: "src/components/PlayerLayer/PlayerLayerProvider.tsx#PlayerLayerProvider" };
}
catch (__react_docgen_typescript_loader_error) { }